



<div class="space"></div>




<p>In paragraphs, set letter-spacing: 0</p>

<p>Use Icon Library if necessary</p>



<!-- ////        Algunos Titulos      /// -->
<div class="content-area">
	<div class="wrap">


		<div class="section-header">
			<div class="wpb_column vc_column_container">
				<div class="vc-column">
					<h2>Nuestros servicios</h2>
					<p></p>
				</div>
			</div>
			<div class="wpb_column vc_column_container">
				<div class="vc-column">
				</div>
			</div>
		</div>




		<div class="ibar">
			<div class="ipiece">
				<div class="call">
                	<img class="sicon" src="../../../../assets/img/sicon.svg" alt="">
                </div>
				<div class="title">
					<h3>Hable hoy con un experto</h3>
				</div>
				<div class="sim-button button14">
                    <span>Contáctenos</span>
                    <img class="arrow22" src="../../../../assets/img/arrow.svg" alt="">
                </div>
			</div>
		</div>



		<!--    BOTON.    -->
		<div class="wide">
			<button class="es-submit" href="#">
                <h3>ENVIAR</h3>
            </button>
		</div>


		<div class="blue">
			<h2>Al estar más cerca de usted, podemos ofrecerle mejores beneficios</h2>
		</div>


		<div class="space"></div>

		<section class="box">
			<div class="flex6 website">
				<div class="elementb box">
					<div class="high">
						<img class="icloud" src="../../../../assets/img/cloud.svg" alt="">
					</div>
					<div class="low">
						<h3>Dedicados 100% a la nube desde nuestro nacimiento</h3>
					</div>
				</div>
			</div>
		</section>





		<section class="box-2">

			<div id="counter" class="flex8">


				<div class="element">
					<div class="inner">
						<img class="gocloud" src="../../../../assets/img/gocloud.svg" alt="">
						<h3>Partner of the year</h3>
						<p>Único partner en la región ganador del Deployment Partner of the Year de Google.</p>
					</div>
					<div class="under">

					</div>
				</div>
				

			</div>
		</section>


<div class="space"></div>


		<section id="ventajas">
			<div class="box2">
				<div class="flex">
					<div class="col">
						<div class="elast">
							<div class="bar">
								<img class="flag" src="../../../../assets/img/star.svg" alt="">
							</div>
							<div class="bar">
								<h2>Más de 10 años</h2>
								<h3>Tenemos más de 10 años de experiencia especializada en la implementación de tecnologías cloud</h3>
							</div>
						</div>
					</div>
					<div class="col">
						<div class="elast">
							<div class="bar">
								<img class="flag" src="../../../../assets/img/trust.svg" alt="">
							</div>
							<div class="bar">
								<h2>Confianza</h2>
								<h3>Las marcas más importantes a nivel mundial, confían en nosotros</h3>
							</div>
						</div>
					</div>
					<div class="col">
						<div class="elast">

							<div class="bar">
								<img class="flag" src="../../../../assets/img/success.svg" alt="">
							</div>
							<div class="bar">
								<h2>Éxito</h2>
								<h3>Garantizamos el éxito de nuestros clientes en la implementación de una estrategia basada en la nube</h3>
							</div>



							
						</div>
					</div>
					<div class="col">
						<div class="elast">
							<div class="bar">
								<img class="flag" src="../../../../assets/img/cup.svg" alt="">
							</div>
							<div class="bar">
								<h2>Partner ganador</h2>
								<h3>Somos el único partner ganador del Google Cloud Deployment Partner of the Year Award en América Latina</h3>
							</div>
						</div>
					</div>
					
				</div>
			</div>
		</section>


<div class="space"></div>


	</div>
</div>